import React, { forwardRef, useMemo } from 'react'
import PropTypes from 'prop-types'
import { useTheme } from 'react-jss'

import { Line } from 'react-chartjs-2'

import getReusableGraphOptions from '../reusableGraphOptions'

import { DEFAULT_GRAPH_COLOR } from '../../../../styles/themes/getDefaultTheme'

const LineGraph = forwardRef((props, ref) => {
  const { data, labels, className, graphColor, format, currencySymbol } = props

  const theme = useTheme()

  const graphData = {
    labels,
    datasets: [
      {
        data: data,
        backgroundColor: graphColor || theme[DEFAULT_GRAPH_COLOR],
        borderColor: graphColor || theme[DEFAULT_GRAPH_COLOR],
        borderRadius: 5,
        borderWidth: 4,
        lineTension: 0.4
      }
    ]
  }

  const graphOptions = useMemo(
    () => getReusableGraphOptions({ format, graphColor, theme, currencySymbol }),
    [format, graphColor, theme, currencySymbol]
  )

  return (
    <div className={className}>
      <Line type="line" data={graphData} options={graphOptions} ref={ref} />
    </div>
  )
})

LineGraph.propTypes = {
  data: PropTypes.array.isRequired,
  labels: PropTypes.array.isRequired,
  className: PropTypes.string,
  graphColor: PropTypes.string,
  format: PropTypes.string,
  currencySymbol: PropTypes.string
}

export default LineGraph
